/*
 *
 * LeadersImport constants
 *
 */

export const DEFAULT_ACTION = "app/LeadersImport/DEFAULT_ACTION"

export const GET_TEMPLATE_WATCHER = "app/LeadersImport/GET_TEMPLATE_WATCHER"
export const GET_TEMPLATE_FAILED = "app/LeadersImport/GET_TEMPLATE_FAILED"
export const GET_TEMPLATE_SUCCESS = "app/LeadersImport/GET_TEMPLATE_SUCCESS"

export const UPLOAD_TEMPLATE_WATCHER =
  "app/LeadersImport/UPLOAD_TEMPLATE_WATCHER"
export const UPLOAD_TEMPLATE_SUCCESS =
  "app/LeadersImport/UPLOAD_TEMPLATE_SUCCESS"
export const UPLOAD_TEMPLATE_FAILED = "app/LeadersImport/UPLOAD_TEMPLATE_FAILED"
